import { rgba } from 'polished';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { cFFFFFF } from '#/colors';
import useLabel from '#/utils/useLabel';

interface Props {
  label: ReactNode;
  value: ReactNode;
  className?: string;
}

export default function Indicator(props: Props) {
  const { label, value, className } = props;
  const [_, labelId] = useLabel('market-info-indicator');

  return (
    <div className={className}>
      <Label id={labelId}>{label}</Label>
      <Value aria-labelledby={labelId}>{value}</Value>
    </div>
  );
}

const Label = styled.div`
  display: block;
  padding-bottom: 8px;
  font-size: 11px;
  line-height: 11px;
  color: ${rgba(cFFFFFF, 0.5)};
`;

const Value = styled.div`
  font-size: 12px;
  line-height: 12px;
  color: ${cFFFFFF};
`;
